var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%"},attrs:{"align":_vm.align}},[_vm._v(" "+_vm._s(_vm.text)+" "),_c('b-icon',{attrs:{"icon":"arrow-repeat","animation":"spin","font-scale":_vm.size}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }